import { upperCaseFirstLetter } from './string';

export function getBusinessLocationInfo(business: Record<string, any>) {
  return [business.city, business.state, business.country]
    .filter(n => n)
    .slice(0, 2)
    .join(', ');
}

export function normalizeLocationName(address = '') {
  const normalizedLocationName = String(address).replace(
    /^(?=\d+)[\d+\w+\S+]+\s*|\s*Unit.+/,
    ''
  );

  return upperCaseFirstLetter(normalizedLocationName);
}
